import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import Request from '@gcloud-npm/utils.request';
import calculateHeaderParams from '@gcloud-npm/node.build-process.build-environments';
import { HOST, PROCESS_NAME, FAMILY_API } from './constants';

const PATH = '/movistar-layer/api/open/retargeting/v1/collect-info';
const EVENT_NAME = 'BAF.SEND_RETARGETING';

const sendRetargeting = ({
  data,
  context,
  idFront = 'VT',
  build = false,
  recaptchaToken,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  const URL_API = `${HOST}${PATH}`;
  const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: 'POST',
    endpoint: URL_API,
    headers: {
      ...headers2Use,
      'Content-Type': 'application/json',
      'X-Recaptcha-Token': recaptchaToken,
    },
    sonda,
    data,
  });
  return request.makeRequest();
};
export default sendRetargeting;
